function getHumanReadableErrorDetail(err) {
  const statusCode = err?.response?.status ?? err?.status;

  if (statusCode === 401)
    return 'Sessão expirada ou não autorizada.';

  if (statusCode === 403)
    return 'Acesso negado.';

  if (statusCode === 404)
    return 'Recurso não encontrado.';

  if (statusCode >= 500)
    return 'Erro interno no servidor.';

  if (statusCode >= 400)
    return `Erro HTTP ${statusCode}.`;

  if (err?.code === 'ECONNABORTED')
    return 'Tempo limite da requisição excedido.';

  if (err?.code === 'ERR_NETWORK')
    return 'Falha de rede ao comunicar com o servidor.';

  return '';
}

function getBaseMessage(consoleMsg) {
  if (typeof consoleMsg !== 'string' || !consoleMsg.trim())
    return 'Não foi possível completar a requisição.';

  const firstPart = consoleMsg.split(':')[0]?.trim();
  return firstPart || 'Não foi possível completar a requisição.';
}

function handleErr(setMessage, consoleMsg, err) {
    const baseMessage = getBaseMessage(consoleMsg);
    const detail = getHumanReadableErrorDetail(err);

  setMessage({ type: 'error', text: baseMessage });

  if (detail) {
    console.error(`${consoleMsg} ${detail}`, err);
    return;
  }

    console.error(consoleMsg, err);
}

function formatPhonePt(value) {
  if (!value) return "";

  const digits = value.replace(/\D/g, "");

  const phone = digits.startsWith("351")
    ? digits.slice(3)
    : digits;

  return `+351 ${phone.slice(0, 1)}${phone.slice(1, 3)} ${phone.slice(3, 6)} ${phone.slice(6, 9)}`.trim();
}

function parseApiDateTime(value) {
  if (typeof value !== 'string')
    return Number.NaN;

  const normalizedValue = value.trim();
  if (!normalizedValue)
    return Number.NaN;

  const directParsed = Date.parse(normalizedValue);
  if (!Number.isNaN(directParsed))
    return directParsed;

  // Handles timestamps with microseconds by trimming to milliseconds.
  const match = normalizedValue.match(/^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2})(?:\.(\d+))?(Z)?$/);
  if (!match)
    return Number.NaN;

  const [, base, fraction = '0', zulu = ''] = match;
  const milliseconds = fraction.padEnd(3, '0').slice(0, 3);

  return Date.parse(`${base}.${milliseconds}${zulu}`);
}

export { handleErr, formatPhonePt, parseApiDateTime };